'use client';
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid'
import toast from 'react-hot-toast';
import CustomToast from '../CustomToast';
import alerts from '@/config/alerts.json'
import useAuth from '@/hooks/useAuth'
import { useLoginModal } from '@/contexts/LoginModalContext';
import BookMobile from './BookMobile';
import { useQuery } from 'react-query';
import { GetDocument } from '@/services/api/personalize/GetDocuments';
import Dedications from './Dedications';
import CoversSelection from './CoversSelection';
import GetCovers from '@/services/api/personalize/GetCovers';
import { GetSettings } from '@/services/api/settings';
import { useCartDispatch } from '@/contexts/CartContext';
import { addItem, updateItem } from 'CartActions';
import { event } from 'nextjs-google-analytics'
import * as fbq from '@/services/fbpixel'
import { usePersonalizeModal } from '@/contexts/PersonalizeModalContext'
import Book from './Book';
import Button from '../Button';
import PackagingSelection from './PackagingSelection';
import { 
  SingleBookIcon,
  DoubleBookIcon,
  AngleDownIcon,
  CloseIcon,
  EditCloseIcon,
  AngleLeftIcon
} from '@/utils/svgIcons';
import PersonalizationFooter from './PersonalizeModalFooter';

export default function PersonalizeModal(
  {
    setPersonalizeModal,
    product,
    inputs,
    editFromCart
  }: {
    setPersonalizeModal: any,
    product: any,
    inputs: string[],
    editFromCart?: any
  }
) {
  const router = useRouter()
  const { closeModal, productData, openModal, updateProductData } = usePersonalizeModal()
  const {user} = useAuth('none')
  const { setIsLoginOpen } = useLoginModal()
  const {data: settings, isLoading: isSettingsLoading} = useQuery(
    ['settings'],
    GetSettings
  )
  const [inputValues, setInputValues] = React.useState<any>([])
    const url_inputs = React.useMemo(() => (
      router.query.inputs != undefined
        ? JSON.parse(router.query.inputs as string)
        : {
          name: router.query.name != undefined
              ? (router.query.name as string)
              : product?.replace_name,
          first_name: '',
          age: '',
          init: product.replace_name.charAt(0),
        }
    ), [router.query.inputs, product.replace_name]);
      let is_edit = productData?.isEdit;
      let uuid: string, name: string, gender: string, age: string, dedication: string, cover: string | undefined;
    React.useEffect(() => {
      const vals: any = {};
      Object.keys(inputs).forEach((input: string) => {
        vals[input] = url_inputs[input];
      });
      setInputValues(vals);

    }, [inputs]);
    const [priceInPersonalize, setPriceInPersonalize] = useState(is_edit === '1'
    ? parseFloat(product.price)
    : parseFloat(product.front_price))
  if(is_edit === '1'){
    uuid = product?.uuid || uuidv4()
    name = product?.name || product?.replace_name
    age = product?.age || ''
    gender = product?.gender === 'Female' ? 'girl' : 'boy'
    dedication = product?.dedication || ''
    cover = product?.cover_id || undefined
  }else {
    is_edit = router.query.is_edit != undefined ? (router.query.is_edit as string) : '0'
    uuid =
    router.query.uuid !== undefined && router.query.uuid !== ''
      ? (router.query.uuid as string)
      : uuidv4();
    name =
    router.query.name != undefined
      ? (router.query.name as string)
      : product?.replace_name
    gender = product.has_female ? 'girl' : product.has_male ? 'boy' : ''
    age =
    router.query.age != undefined ? (router.query.age as string) : ''
    dedication =
    router.query.dedication != undefined
      ? (router.query.dedication as string)
      : ''
    cover =
    router.query.cover != undefined ? (router.query.cover as string) : undefined
  }

  const [childName, setChildName] = useState(name|| '');
  const [inputAge, setInputAge] = React.useState<string>(is_edit === '1' ? product?.inputs.age : '')
  const [inputPackaging, setInputPackaging] = React.useState(is_edit === '1' ? product?.packaging : false);
  const initialGender =
  is_edit === '1'
    ? product?.gender === 'Female'
      ? 'Female'
      : 'Male'
    : product?.has_female === true
      ? 'Female'
      : 'Male';
  const [childgender, setChildGender] = React.useState(initialGender);
  const [confirmCart, setConfirmCart] = React.useState(false);
  const desktopRef = React.useRef<any>()
  const [counter, setCounter] = React.useState(0)
  const [page, setPage] = React.useState(0)
  React.useEffect(() => {
      const intervalId = setInterval(() => {
        setCounter(prevCounter => prevCounter + 1)
        setPage(
          desktopRef?.current?.pageFlip()?.getPageCount() -
          desktopRef?.current?.pageFlip()?.getCurrentPageIndex(),
        )
      }, 500)
  
      return () => clearInterval(intervalId)
    }, []) 
  const [inputDedication, setInputDedication] = React.useState<string>(dedication)
  const [option, setOption] = React.useState<undefined | number>(undefined)
  const [inputCover, setInputCover] = React.useState<string | { name: string } | undefined>(cover)
  const handleNextStep = () => {
        if (!user) {
            toast.custom((t) => <CustomToast type='error' t={t} message={alerts.login_first} />, {
              duration: 2500,
            });
          setIsLoginOpen(true)
          return
        }
        if(!childName || childName == ''){
          toast.custom((t) => <CustomToast type='error' t={t} message={'Please Enter or change child name before moving next'} />, {
          duration: 2500,
          });
          return
        }
        if(childgender === ''){
          toast.custom((t) => <CustomToast type='error' t={t} message={'Please Enter child gender before moving next'} />, {
              duration: 2500,
            });
          return
        }
        if(step === 'info'){
          markOptionCompleted('name', true);
          markOptionCompleted('gender', true);
          markOptionCompleted('child', true);
        }
        setStep('review');
  }
  const handleSave = () => {
    if(activeOption === 'dedication'){
      if(inputDedication === ''){
        toast.custom((t) => <CustomToast type='error' t={t} message={'الرجاء اختيار أحد الإهداءات المحددة أو إدخال إهدائك الخاص'} />, {
          duration: 2500,
        });
        return
      }
      markOptionCompleted('dedication', true)
    }
    if(activeOption === 'cover'){
      if(inputCover != '1' && inputCover != '2'){
        toast.custom((t) => <CustomToast type='error' t={t} message={'الرجاء اختيار نوع الغلاف'} />, {
          duration: 2500,
        });
        return
      }
      markOptionCompleted('cover', true)
    }
    if(activeOption === 'packaging'){
      markOptionCompleted('packaging', true);
    }
    setStep('review');
  }
  const UpdateValue = (input: string, value: string) => {
    const vals: any = { ...inputValues }
    vals[input] = value
    setInputValues(vals)
  }
  const customInputs: Record<string, any> = React.useMemo(() => ({
    name: childName || productData?.product?.replace_name,
    first_name: '',
    age: inputAge || productData?.product.age,
    init: childName?.charAt(0) || productData?.product?.replace_name.charAt(0),
    dedication: inputDedication || productData?.product.dedication || '',
  }), [productData?.product.name, productData?.product.age, productData?.product.dedication]);
  const [step, setStep] = useState<'info' | 'review' | 'edit'>('info');
  const [activeOption, setActiveOption] = useState<string>('name');
  const [dedicationModal, setDedicationModal] = React.useState(false);
  const [coverModal, setCoverModal] = React.useState(false);
  const [packageModal, setPackageModal] = React.useState(false);
  const [nameModal, setNameModal] = React.useState(false);
  const [bookView, setBookview] = React.useState<'single'|'double'>('single')
  const [bookViewMenu, setBookViewMenu] = React.useState(false);
  const { data, isLoading } = useQuery(
      [
        'personalize',
        {
          slug: product?.slug || productData?.product?.product_slug || '',
          inputs: JSON.stringify(customInputs),
          gender: childgender,
          type: 2,
          //type: type,
        },
      ],
      GetDocument,
    )
  const rawCoverPages = data?.cover_pages.name
  const product_id = is_edit === '1' ? product?.product_id : product?.id;
  const { data: covers } = useQuery(['covers', product_id], GetCovers)
  let coverType = '';
  if (rawCoverPages?.includes('hardc')) {
    coverType = 'غلاف قوي (hardc)';
  } else if (rawCoverPages?.includes('softc')) {
    coverType = 'غلاف ليّن (softc)';
  } else {
    coverType ='إضافة نوع الغلاف'; // optional fallback
  }
  const InitialOptions = [
    {
      id: 'child',
      label: 'تفاصيل الطفل',
      value: childName ? childName : product.replace_name,
      completed: false,
    },
    // {
    //   id: 'name',
    //   label: 'اسم الطفل',
    //   value: childName ? childName : product.replace_name,
    //   completed: false,
    // },
    // {
    //   id: 'gender',
    //   label: 'الجنس',
    //   value:
    //     !childgender || childgender === ''
    //       ? 'بنت'
    //       : childgender === 'Female'
    //       ? 'بنت'
    //       : 'ولد',
    //   completed: false,
    // },
    {
      id: 'dedication',
      label: 'الإهداء',
      value: 
        inputDedication !== ''
        ? inputDedication
        : 'أدخل الإهداء'
      ,
      completed: false,
    },
    {
      id: 'cover',
      label: 'غلاف الكتاب',
      value: typeof inputCover === 'object' && inputCover?.name
        ? inputCover?.name
        : inputCover || coverType,
      completed: false,
    },
    {
      id: 'packaging',
      label: 'التغليف المميز',
      value: inputPackaging === true ? 'تمت إضافة التغليف' :'بدون تغليف',
      completed: false,
    },
  ];
  const [options, setOptions] = useState(InitialOptions);
  const markOptionCompleted = (id: string, completed: boolean) => {
    setOptions(prev =>
      prev.map(option =>
        option.id === id ? { ...option, completed } : option
      )
    );
  };
  const cartDispatch = useCartDispatch()
  const addToCart = () => {
  const selectedCover = covers.find((x: any) => x.id == inputCover);
  const selectedPackagingPrice = inputPackaging === false ? 0 : parseFloat(settings?.packaging_price || '0');
  const productBasePrice = is_edit === '1'
    ? parseFloat(product.price)
    : parseFloat(product.front_price);

  const selectedCoverInItem = covers.find((x: any) => x.id == inputCover);
  const selectedCoverPrice = parseFloat(selectedCoverInItem?.price || '0');
  const total_price = productBasePrice + selectedCoverPrice + selectedPackagingPrice;

  const itemDemoName = product?.demo_name
    ?? product?.product?.demo_name
    ?? productData?.product?.demo_name
    ?? ''; // Fallback for edit mode

  const itemSlug = product?.slug
    ?? product?.product_slug
    ?? productData?.product?.product_slug;

  const itemImage = product?.images?.[0]
    ?? product?.image
    ?? product?.product?.image;

  const item = {
    product_id: product?.product_id || product?.id,
    uuid: uuid,
    replace_name: childName,
    inputs: {
      name: childName,
      age: inputAge,
    },
    product_name: product?.product_name,
    demo_name: itemDemoName,
    cover_id: selectedCover?.id,
    default_replace_name: product?.replace_name,
    image: itemImage,
    product_slug: itemSlug,
    price: productBasePrice,
    quantity: 1,
    total: total_price,
    product_type: 1 as const,
    discount: 0,
    gender: childgender,
    dedication: inputDedication,
    packaging: 
      inputPackaging === false ? {
        name: 'No-Packaging',
        price: 0
      } : {
        name: 'Packaging',
        price: settings?.packaging_price
      }
  };

  if (is_edit === '1') {
    cartDispatch(updateItem(item));
    toast.custom((t) => <CustomToast type='success' t={t} message={alerts.cart_updated} />);
  } else {
    cartDispatch(addItem(item));
    toast.custom((t) => <CustomToast type='success' t={t} message={alerts.cart_added} />);
  }

  // FB Events
  event('add_to_cart', {
    currency: 'ILS',
    items: [
      {
        item_id: item.product_id,
        item_name: item.product_name,
        item_variant: selectedCover?.name,
        price: total_price,
        quantity: 1,
      },
    ],
  });

  fbq.event('AddToCart', {
    content_name: item.product_name,
    currency: 'ILS',
    value: total_price,
  });
  router.push(
    `/products?name=${url_inputs.name}`
  );
  setPersonalizeModal(false);
};
  useEffect(() => {
  if (!childName && product?.replace_name) {
    setChildName(product.replace_name);
  }
  setOptions(prevOptions =>
    prevOptions.map(option =>
      option.id === 'name'
        ? { ...option, value: childName }
        : option
    )
  );
  setOptions(prevOptions =>
    prevOptions.map(option =>
      option.id === 'dedication'
        ? { ...option, value: inputDedication != '' ? inputDedication : 'أدخل الإهداء' }
        : option
    )
  );
  setOptions(prevOptions =>
    prevOptions.map(option =>
      option.id === 'cover'
        ? {
            ...option,
            value:
              typeof inputCover === 'object' && inputCover?.name
                ? inputCover.name
                : String(inputCover || coverType) === '1'
                ? 'غلاف ليّن'
                : String(inputCover || coverType) === '2'
                ? 'غلاف مُقَوَّى'
                : 'اختر الغلاف', // fallback
          }
        : option
    )
  );
    setOptions(prevOptions =>
    prevOptions.map(option =>
      option.id === 'packaging'
        ? {
            ...option,
            value: inputPackaging === true ? 'تمت إضافة التغليف' :'بدون تغليف'
          }
        : option
    )
  );
}, [product?.replace_name, childName, childgender, inputDedication, inputCover, inputPackaging]);
useEffect(() => {
  const vals: Record<string, string> = {};
  if(is_edit === '1'){
    Object.keys(inputs).forEach((input: string) => {
    const urlValue = url_inputs[input];
    const fallbackValue = customInputs[input];
    vals[input] =
      urlValue !== undefined && urlValue !== null && String(urlValue).trim() !== ''
        ? urlValue
        : fallbackValue ?? '';
  });
  if(is_edit === '1'){
    setStep('review');
    markOptionCompleted('child', true);
    markOptionCompleted('gender', true);
    markOptionCompleted('name', true);
    markOptionCompleted('dedication', true);
    markOptionCompleted('cover', true);
    markOptionCompleted('packaging', true);
  }
  setInputValues(vals);
  }
}, [inputs, url_inputs, customInputs]);
useEffect(()=>{
  const checkReplaceName =
          (is_edit === '1' && product?.name !== undefined)
            ? product?.name
            : (childName !== undefined && childName !== '')
              ? childName
              : product?.replace_name;
  const newDedication = inputDedication.replace('{basmti}', checkReplaceName);
      setInputDedication(newDedication);
      setInputDedication(
        newDedication.replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          '',
        )
      );
  updateProductData({dedication: newDedication});
}, [inputDedication, childName])
React.useEffect(()=>{
  const selectedPackagingPrice = inputPackaging === false ? 0 : parseFloat(settings?.packaging_price || '0');
  const productBasePrice = is_edit === '1'
    ? parseFloat(product.price)
    : parseFloat(product.front_price);

  const selectedCoverInItem = covers?.find((x: any) => x.id == inputCover);
  const selectedCoverPrice = parseFloat(selectedCoverInItem?.price || '0');
  let total = productBasePrice;
  if(selectedPackagingPrice > 0 && selectedPackagingPrice !== null && selectedPackagingPrice !== undefined && !Number.isNaN(selectedPackagingPrice)){
    total += selectedPackagingPrice;
  }

  if (selectedCoverPrice > 0 && selectedCoverPrice !== null && selectedCoverPrice !== undefined && !Number.isNaN(selectedCoverPrice)){
    total += selectedCoverPrice;
  }
  setPriceInPersonalize(total);
}, [inputCover, inputPackaging]);
  return (
    <AnimatePresence>
      <motion.div 
        className="fixed inset-0 bg-white z-[140] flex flex-col text-right"
        key="modal"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 30 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        {/* ADD TO CART CONFIRMATION MODAL */}
        {confirmCart && is_edit === '0' && (
          <AnimatePresence>
            <motion.div 
            key="confirmation-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="absolute inset-0 bg-black/40 z-[150] flex items-center justify-center"
          >
            <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center shadow-lg">
              <div className='w-full flex items-center justify-center mb-6'>
                <img src="/images/addtocart.svg" alt="Add to cart icon" className='w-12 h-12 '/>
              </div>
              <h3 className="text-lg font-semibold mb-2 px-4">سنقوم باضافة طلبك الى السلة</h3>
              <p className="text-sm text-[##52575C] px-4">يمكنك ايضا تصفّح المزيد من القصص واستمتع بتشكيلة متنوعة عبر صفحة المنتجات.</p>
              <div className="flex justify-center gap-3 mt-6 w-full">
                <button onClick={()=>{
                  setConfirmCart(false);
                  addToCart();
                }} className="bg-primary text-white px-10 py-4 rounded hover:bg-primary-700 font-medium">أضف الي السلة</button>
              </div>
            </div>
          </motion.div>
          </AnimatePresence>
        )}

        {/* BOOK VIEW MENU */}
        {(step === 'review' && bookViewMenu === true) && (
          <div className='hidden absolute top-20 left-1/2 z-[140] -translate-x-1/2 bg-white py-2 px-4 lg:flex items-center justify-center gap-4 rounded-2xl'>
          <div className={`flex flex-col gap-2 py-2 px-4 items-center justify-center ${bookView === 'single' ? 'bg-success text-primary rounded-md' : 'text-[#00214D66]'}`} onClick={()=>{
            setBookview('single');
            setBookViewMenu(false);
          }}>
            <div className="w-5 h-5">
              <SingleBookIcon/>
            </div>
            <p className='font-normal text-base mt-2'>صفحة واحدة</p>
          </div>
          <div className={`flex flex-col gap-2 py-2 px-4 items-center justify-center ${bookView === 'double' ? 'bg-success text-primary rounded-md' : 'text-[#00214D66]'}`}  
          onClick={()=>{
            setBookview('double');
            setBookViewMenu(false);
          }}>
            <div className="flex items-center justify-center gap-1">
              <DoubleBookIcon/>
            </div>
            <p className='font-normal text-base mt-2'>عرض صفحتين</p>
          </div>
        </div>
        )}

        {/* THE ANGLE DOWN BUTTON IF THE BOOK VIEW MOBILE MENU IS CLOSED */}
        {(bookViewMenu === false && step !== 'info') && (
          <div className='hidden absolute top-12 left-1/2 z-[140] -translate-x-1/2 bg-white p-1 lg:flex items-center justify-center rounded-full shadow-2xl' onClick={()=>{setBookViewMenu(true)}}>
            <AngleDownIcon/>
          </div>
        )}

        {/* MODALS FOR DESKTOP VIEW */}
        {dedicationModal && (
          <AnimatePresence>
            <motion.div 
            key="confirmation-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="hidden absolute inset-0 bg-black/40 z-[150] lg:flex items-center justify-center"
          >
            <div className="bg-white rounded-lg max-w-sm w-full text-center shadow-lg  lg:min-w-[700px]">
              <Dedications
                setInputDedication={setInputDedication}
                inputDedication={inputDedication}
                setOption={setOption}
                gender={childgender}
                product={product}
                setDedicationModal={setDedicationModal}
                updateProductData={updateProductData}
                handleSave={handleSave}
                isEdit={is_edit}
                markOptionCompleted={markOptionCompleted}
                nameFromPersonalize={childName}
              />
            </div>
          </motion.div>
          </AnimatePresence>
        )}

        {packageModal && (
          <AnimatePresence>
            <motion.div 
            key="confirmation-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="hidden absolute inset-0 bg-black/40 z-[150] lg:flex items-center justify-center"
          >
            <div className="bg-white rounded-lg max-w-sm w-full text-center shadow-lg  lg:min-w-[700px] lg:py-8">
              {!isSettingsLoading ?
                (<PackagingSelection
                product={productData?.product}
                inputPackaging={inputPackaging}
                setInputPackaging={setInputPackaging}
                isEdit={is_edit}
                setPackageModal={setPackageModal}
                updateProductData={updateProductData}
                handleSave={handleSave}
                packagingPrice={settings?.packaging_price}
                markCompleted={markOptionCompleted}
              />) : (<p>Loading the packages</p>)
              }
            </div>
          </motion.div>
          </AnimatePresence>
        )}

        {coverModal && (
          <AnimatePresence>
            <motion.div 
            key="confirmation-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="hidden absolute inset-0 bg-black/40 z-[150] lg:flex items-center justify-center"
          >
            <div className="bg-white rounded-lg max-w-sm w-full text-center shadow-lg  lg:min-w-[600px] lg:py-8">
              <CoversSelection
                product={productData?.product}
                inputCover={typeof inputCover === 'object' && inputCover !== null ? inputCover.name : inputCover}
                setInputCover={setInputCover}
                isEdit={is_edit}
                setCoverModal={setCoverModal}
                updateProductData={updateProductData}
                handleSave={handleSave}
                markOptionCompleted={markOptionCompleted}
              />
            </div>
          </motion.div>
          </AnimatePresence>
        )}

        {nameModal && (
          <AnimatePresence>
            <motion.div 
            key="confirmation-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="hidden absolute inset-0 bg-black/40 z-[150] lg:flex items-center justify-center"
          >
            <div className="bg-white rounded-lg max-w-sm w-full text-center shadow-lg lg:px-8 lg:py-12 lg:max-auto lg:min-w-[700px]">
              <div className='lg:max-w-full'>
                 <h1 className="block lg:hidden text-2xl font-normal text-black text-center">لمن نصنع هذه القصة؟</h1>
                <div className='hidden lg:flex w-full items-center justify-between lg:mb-3'>
                  <h1 className="text-2xl font-normal text-black text-center lg:text-start">لمن نصنع هذه القصة؟</h1>
                  <button 
                      className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
                      onClick={()=>{
                        setNameModal(false);
                      }}
                    >
                    <CloseIcon/>
                  </button>
                </div>
                  <div className="inputs flex flex-col gap-4 items-center mt-6">
                  {Object.entries(inputValues).map(([key, value]) => {
                    const isEmpty =
                      value === null ||
                      value === undefined ||
                      (typeof value === 'string' && value.trim() === '');

                    if (isEmpty && is_edit === '1') {
                      return null;
                    }

                    return (
                      <div key={key} className="w-full form-group">
                        <label className="block text-xs">
                          {key === 'name' && 'الاسم الكامل للطفل'}
                          {key === 'first_name' && 'الاسم الأول للطفل'}
                          {key === 'age' && 'عيد الميلاد حسب العمر (مثال: 4 )'}
                          {key === 'init' && 'ادخل الحرف الاول من اسم طفلك'}
                        </label>
                        <input
                          type={key === 'age' ? 'number' : 'text'}
                          name={key}
                          min="1"
                          max="100"
                          onChange={e => {
                            const val = e.target.value;
                            UpdateValue(key, val);
                            if (key === 'name') setChildName(val);
                            if (key === 'age') setInputAge(val);
                          }}
                          value={key === 'age' ? inputAge : inputValues[key] ? inputValues[key] : ''}
                          className="border-1 text-primary border-gray-300 w-full font-semibold placeholder:font-light mt-2 placeholder:opacity-70 py-3 text-xs px-3 focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent rounded-md"
                        />
                      </div>
                    );
                  })}
                </div>
                  <Button
                    type="button"
                    bg="primary"
                    onClick={() => {
                      updateProductData({name: childName, age: inputAge, gender: childgender});
                      handleSave();
                      setNameModal(false)
                    }}
                    classes={['py-3', 'w-full', 'mt-4', 'font-semibold', 'hidden', 'lg:block', 'lg:mt-6']}>
                    {'متابعة'}
                  </Button>
              </div>
            </div>
          </motion.div>
          </AnimatePresence>
        )}

      {/* HEADER */}
      <div className="flex justify-between items-center px-4 py-3 border-b shadow-sm">
        <div className="w-6" /> {/* Spacer to center title */}
        {typeof productData?.product?.demo_name === 'string' && (
          <h2 className={`${step === 'review' ? 'text-2xl': 'text-base'} text-black mx-auto`}>
            {productData.product.demo_name.split('{basmti}')[0]}
            <span className="text-success-500">
              {childName || productData.product.replace_name}
            </span>
            {productData.product.demo_name.split('{basmti}')[1]}
          </h2>
        )}

        {(step === 'info' || step === 'edit') && (
          <button 
            className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
            onClick={()=>{
              if(step === 'info') {
                setPersonalizeModal(false);
              }
              if(step === 'edit'){
                setStep('review');
                setActiveOption('');
              }
            }}
          >
          <EditCloseIcon/>
          </button>
        )}
      </div>

      {/* SCROLLABLE CONTENT FOR MOBILE DEVICES */}
      {/* REVIEW VIEW WHERE ONLY THE BOOK IS SHOWN WITH FOOTER */}
      {step === 'review' && (
        <>
          {isLoading ? (
            <div className='flex-1 overflow-y-auto px-4 py-6 bg-[#FFFCEB] flex items-center justify-center gap-4'>
              <div className="w-6 h-6 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
              <h2 className="text-lg font-semibold leading-none">جاري تحميل الكتاب...</h2>
            </div>
          ) : (
            <div className={`flex-1 overflow-y-auto px-2 ${bookView === 'single' ? 'py-6' : 'py-3'} space-y-6 bg-[#FFFCEB]  hide-scrollbar`}>
              {bookView === 'single' ? (
                <BookMobile
                  pages={data?.pages?.pdf}
                  cover_pages={data?.cover_pages?.pdf}
                  cover_pages_predefined_texts={data?.cover_pages_predefined_texts}
                  inputDedication={inputDedication}
                  product={product}
                  pages_predefined_texts={data?.pages_predefined_texts}
                  pages_dedication_texts={data?.pages_dedication_texts}
                  setStep={setStep}
                  setActiveOption={setActiveOption}
                  setDedicationModal={setDedicationModal}
                />
              )
              :
              (
                <Book
                  pages={data?.pages.pdf}
                  cover_pages={data?.cover_pages.pdf}
                  cover_pages_predefined_texts={
                    data?.cover_pages_predefined_texts
                  }
                  inputDedication={inputDedication}
                  product={product}
                  pages_predefined_texts={data?.pages_predefined_texts}
                  pages_dedication_texts={data?.pages_dedication_texts}
                  desktopRef={desktopRef}
                />
              )
              }
            </div>
          )}
        </>
      )}
      {/* CHILD DETAIL CONTENTS FOR MOBILE DEVICES */}
      {(step === 'info' || step ==='edit') && (activeOption === 'name' || activeOption === 'gender' || activeOption === 'age' || activeOption === 'init' || activeOption === 'first_name' || activeOption === 'child') && (
        <div className="flex-1 overflow-y-auto px-4 py-6 space-y-6 bg-[#FFFCEB]">
          <div className='lg:mx-auto lg:max-w-xl'>
            <h1 className="text-2xl font-normal text-black text-center">لمن نصنع هذه القصة؟</h1>
              <div className="inputs flex flex-col gap-4 items-center mt-6">
                  {Object.entries(inputValues).map(([key, value]) => {
                    const isEmpty =
                      value === null ||
                      value === undefined ||
                      (typeof value === 'string' && value.trim() === '');

                    if (isEmpty && is_edit === '1') {
                      return null;
                    }

                    return (
                      <div key={key} className="w-full form-group">
                        <label className="block text-xs">
                          {key === 'name' && 'الاسم الكامل للطفل'}
                          {key === 'first_name' && 'الاسم الأول للطفل'}
                          {key === 'age' && 'عيد الميلاد حسب العمر (مثال: 4 )'}
                          {key === 'init' && 'ادخل الحرف الاول من اسم طفلك'}
                        </label>
                        <input
                          type={key === 'age' ? 'number' : 'text'}
                          name={key}
                          min="1"
                          max="100"
                          onChange={e => {
                            const val = e.target.value;
                            UpdateValue(key, val);
                            if (key === 'name') setChildName(val);
                            if (key === 'age') setInputAge(val);
                          }}
                          value={inputValues[key] ?? ''}
                          className="border-1 text-primary border-gray-300 w-full font-semibold placeholder:font-light mt-2 placeholder:opacity-70 py-3 text-xs px-3 focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent rounded-md"
                        />
                      </div>
                    );
                  })}
                </div>
          </div>
          {step === 'info' && (
            <div className='hidden lg:flex flex-col gap-4 items-center justify-center mx-auto bg-white px-4 py-6 max-w-3xl'>
              <button className={`w-full lg:max-w-xl text-white p-4 rounded-md bg-primary  font-medium`} onClick={()=>{
                const filledInputs = Object.keys(inputs).filter(key => {
                  const value = inputValues[key];
                  return value !== null && value !== undefined && String(value).trim() !== '';
                });

                if (filledInputs.length < Object.keys(inputs).length) {
                  toast.custom(t => (
                    <CustomToast t={t} type="error" message="الرجاء إدخال جميع الحقول المطلوبة" />
                  ));
                  return;
                }
                updateProductData({name: childName, age: inputAge, gender: childgender});
                handleNextStep();
              }}>
                {'متابعة'}
              </button>
              <button className="mt-2 text-primary-500 text-sm font-medium flex items-center justify-center w-full text-center" onClick={()=>setPersonalizeModal(false)}>
                الرجوع للصفحة السابقة 
                <span className="mr-3">
                  <AngleLeftIcon/>
                </span>
              </button>
            </div>
          )}
        </div>
      )}
      {/* DEDICATION VIEW FOR MOBILE DEVICES */}
      {step === 'edit' && activeOption === 'dedication' && (
        <>
        <div className='flex-1 lg:hidden overflow-y-auto p-4 bg-[#FFFCEB] flex flex-col text-black'>
          <h2 className='text-sm font-normal'>أضف إهداء مميز مجانًا</h2>
          <Dedications
            setInputDedication={setInputDedication}
            inputDedication={inputDedication}
            setOption={setOption}
            gender={childgender}
            product={product}
            nameFromPersonalize={childName}
          />
        </div>
        </>
      )}
      {/* COVER VIEW FOR MOBILE DEVICES */}
      {step === 'edit' && activeOption === 'cover' && (
        <div className='flex-1 overflow-y-auto p-4 bg-[#FFFCEB]'>
          <CoversSelection
            product={productData?.product}
            inputCover={typeof inputCover === 'object' && inputCover !== null ? inputCover.name : inputCover}
            setInputCover={setInputCover}
            isEdit={is_edit}
          />
        </div>
      )}
      {/* PACKAGING VIEW FOR MOBILE DEVICES */}
      {step === 'edit' && activeOption === 'packaging' && (
        <div className='flex-1 overflow-y-auto p-4 bg-[#FFFCEB]'>
          {!isSettingsLoading ?
                (<PackagingSelection
                product={productData?.product}
                inputPackaging={inputPackaging}
                setInputPackaging={setInputPackaging}
                isEdit={is_edit}
                setPackageModal={setPackageModal}
                updateProductData={updateProductData}
                handleSave={handleSave}
                packagingPrice={settings?.packaging_price}
              />) : (<p>Loading the packages</p>)
              }
        </div>
      )}
      {/* FOOTER */}
             <PersonalizationFooter
         step={step}
         activeOption={activeOption}
         options={options}
         childName={childName}
         inputAge={inputAge}
         childgender={childgender}
         inputDedication={inputDedication}
         inputCover={inputCover}
         inputPackaging={inputPackaging}
         is_edit={is_edit}
         priceInPersonalize={priceInPersonalize}
         inputs={inputs}
         inputValues={inputValues}
         settings={settings}
         setStep={setStep}
         setActiveOption={setActiveOption}
         setNameModal={setNameModal}
         setDedicationModal={setDedicationModal}
         setCoverModal={setCoverModal}
         setPackageModal={setPackageModal}
         setConfirmCart={setConfirmCart}
         setPersonalizeModal={setPersonalizeModal}
         updateProductData={updateProductData}
         handleNextStep={handleNextStep}
         handleSave={handleSave}
         addToCart={addToCart}
       />
      </motion.div>
    </AnimatePresence>
  );
}
